import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import EZAlert from "@components/popups/EZAlert";
import ComponentLoading from "@components/ui/ComponentLoading";
import Pager from "@components/ui/Pager";
import ApiProxy from "@ts/ApiProxy";
import GS from "@ts/GlobalSetting";
import { ScrollListener } from "@ts/sframe/ScrollListener";
import ProductNav from "./ProductNav";
import { Product } from "./ProductTypes";
import Review from "./Review";
import schema from "@schema/product/get-review-list.json"
import { Common } from "../common/CommonTypes";

const SETTING =
{
  pageSize: 3,
  pagerMaxSize: 10
};

export default class ReviewList extends ComponentBase {
  isInit: boolean = false;

  data: Product.ReviewListData;

  // pager: Pager;

  // loading: ComponentLoading;

  $btnMore: JQuery;

  nextPageIndex: number = 0;
  isEnd: boolean = false;
  isLocking: boolean = false;

  constructor(elem: ComponentElem) {
    super(elem);

    let pageData: Product.PageData = ApiProxy.getPageData();

    this.$root.find(".score").text(pageData.review_overview.average_score);
    this.$root.find(".max-value").text(GS.reviewMaxRating);

    // this.loading = new ComponentLoading(5, `rgba(255, 255, 255, .8)`);
    // this.loading.bindWith(this.$root);

    this.$root.find(".reviews").empty();

    this.$btnMore = this.$root.find(".btn-more");

    // pager
    // let pagerElem: ComponentElem = this.$root.find(`[component="pager"]`)[0] as ComponentElem;
    // this.pager = new Pager(pagerElem);
    // this.pager.emiiter.addListener("change", (pageIndex)=>
    // {
    //   this.toPage(pageIndex);
    // });

    this.$btnMore.on("click", (event: Event) => {
      event.preventDefault();

      this.toPage(this.nextPageIndex);
    });

    this.toPage(this.nextPageIndex);
  }

  toPage(pageIndex: number) {
    // console.log(`to page: ${pageIndex}`);    

    if (this.isLocking || this.isEnd) return;

    let pageData = ApiProxy.getPageData() as Product.PageData;

    let params =
    {
      "product_id": pageData.id,
      "start_index": pageIndex * SETTING.pageSize,
      "page_size": SETTING.pageSize
    };

    // this.pager.toggleLocking(true);
    this.isLocking = true;
    // this.loading.show();
    this.$btnMore.attr("state", "loading");

    let api = "product/get-review-list";


    // console.log(params);    

    ApiProxy.callApi(api, params, { schema: schema }).then((result) => {
      if (result) {
        this.data = result.data;
        this.update();
      }
    }).catch((error: Error) => {
      EZAlert.instance.alert(error.message);
    });
  }

  update() {
    // if(this.isInit) ProductNav.to("#product-detail-5");
    this.isInit = true;

    let pagingInfo: Common.PagingInfo = this.data.paging_info;

    let startIndex = pagingInfo.start_index,
      pageSize = pagingInfo.page_size,
      totalCount = pagingInfo.total_count,
      pageIndex = Math.floor(startIndex / pageSize);

    this.nextPageIndex = pageIndex + 1;

    this.isEnd = ((pageIndex + 1) * pageSize) >= totalCount;

    this.$root.find(".count").text(totalCount);

    // create items 
    let dataList = this.data.data_list;
    // let $reviewContainer = this.$root.find(".reviews").empty();
    let $reviewContainer = this.$root.find(".reviews");

    dataList.forEach((data: Product.ReviewData) => {
      let review: Review = new Review(Review.createElem(), data);
      $reviewContainer.append(review.$root);

      setTimeout(() => {
        review.$root.attr("lazy-loading", "done");
      }, 100);
    })

    // this.pager.toggleLocking(false);
    // this.loading.hide();
    this.isLocking = false;
    // this.pager.reset(parseInt(this.data.page_size), parseInt(this.data.total_count), parseInt(this.data.page_index));
    this.$btnMore.attr("state", this.isEnd ? "end" : "idle");

    ScrollListener.update();


  }
}